import React from 'react'
import "../../styles/ApprovalHeader.css"
import CommonNavbar from '../../Navbar/CommonNavbar'

const MailHeader = ({onSearch}) => {
  return (
    <div>
      <header>
        <nav className="nav-items" >
          <p className='approval-config-p' style={{ fontSize: "14px" }}>Mail Configuration</p>

          <CommonNavbar onSearch={onSearch} />

        </nav>
      </header>
    </div>
  )
}

export default MailHeader